import Popper from 'popper.js';
import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> &
  {
    tooltipText: React.ReactNode;
    tooltipPlacement?: Popper.Placement
  }

export class TooltipSpan extends React.Component<Props> {
  readonly spanRef = React.createRef<HTMLSpanElement>();

  render() {
    const spanRef = this.spanRef;
    const {tooltipText, tooltipPlacement, children, ...rest} = this.props;
    return (
      <>
        <span ref={spanRef}
              {...rest}>
              {children}
        </span>
        <UncontrolledTooltip target={spanRef}
                             placement={tooltipPlacement}>
          {tooltipText}
        </UncontrolledTooltip>
      </>);
  }
}
